import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { libraryReleaseClient } from '../Library/reuseClient';
import { THEME_RECEIVERS, themeReviewLabel } from './CustomerThemeEvidence';
export function CustomerThemeRelatedWork({ captureProjectId, themeId }) {
    const related = useQuery({
        queryKey: [
            'customer-theme-evidence',
            'related',
            captureProjectId,
            themeId
        ],
        gcTime: 0,
        retry: false,
        queryFn: async ()=>{
            const { summaries } = await libraryReleaseClient.listCustomerContexts({
                captureProjectId,
                themeId
            });
            const rows = await Promise.all(summaries.map((row)=>libraryReleaseClient.listLibraryReuses({
                    libraryItemId: row.libraryItemId
                })));
            return rows.flatMap((row)=>row.reuses);
        }
    });
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2",
        "data-testid": Testids.customerThemeEvidence.related,
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                className: "font-medium",
                children: "Related work using shared evidence"
            }),
            related.isFetching && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                "aria-live": "polite",
                children: "Loading related work…"
            }),
            related.isError && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        role: "alert",
                        children: "Related work is unavailable."
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        variant: "secondary",
                        onClick: ()=>related.refetch(),
                        children: "Retry related work"
                    })
                ]
            }),
            !related.isFetching && !related.isError && !related.data?.length && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                children: "No permitted related uses. Share an insight, then select that shared theme in a receiving area."
            }),
            !related.isFetching && !related.isError && related.data?.map((row)=>{
                const receiver = row.receivingObjectType.replace('customer_theme.', '');
                const destination = receiver === 'proposal' ? `/proposal/${encodeURIComponent(row.receivingObjectId)}/v2?themeEvidence=1` : `/capture/${encodeURIComponent(row.receivingObjectId)}?tab=${receiver === 'solution' ? 'solution' : receiver === 'competition' ? 'overview' : 'outputs'}#theme-evidence-${receiver}`;
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs(Link, {
                            "data-testid": Testids.customerThemeEvidence.destination,
                            to: destination,
                            children: [
                                THEME_RECEIVERS[receiver],
                                " · basis v",
                                row.sourceVersion
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SpecraText, {
                            as: "p",
                            size: "meta",
                            children: themeReviewLabel(row.status)
                        })
                    ]
                }, row.reuseId);
            })
        ]
    });
}
